<form [formGroup]="formCellManualEdit" (submit)='onSubmit()' novalidate>
  <div class="modal-header">
    <div class="modal-header-content">
      <h1 class="modal-title">Edit value</h1>
      <h2 class="modal-subtitle">Enter the adjustment for the current value.</h2>
    </div>
    <i class="ic-close icon-size-32" (click)="activeModal.close()"></i>
  </div>
  <div class="modal-body">
    <div class="form-container">
      <div class="form-group">
        <label for='originalValueId' class="input-title">Original value</label>
        <input
          id="originalValueId"
          formControlName="originalValue"
          class="form-control"
          type="text"
          readonly
          placeholder="Insert value"
        >
      </div>
      <div class="form-group">
        <label for='modify' class="input-title" [class.text-error]="submitted && form.modifyValue.invalid">Modify value</label>
        <input
          id="modify"
          formControlName="modifyValue"
          class="form-control"
          type="number" 
          (ngModelChange)="getValue($event)"
          placeholder="Insert value"
          ngbAutofocus
          step="0.01"
          [class.is-invalid]="submitted && form.modifyValue.invalid"
        >
        <small class="invalid-feedback text-error" *ngIf="form.modifyValue.errors && submitted">
          <span *ngIf="form.modifyValue.errors.required">Modify value is mandatory. Please fill the field!</span>
          <span *ngIf="form.modifyValue.errors.pattern || form.modifyValue.errors.min">Insert a value equal to or greater than 0</span>
        </small>
      </div>
      <div class="form-group">
        <label for='newValueId' class="input-title">New value</label>
        <input
          id="newValueId"
          formControlName="newValue"
          class="form-control"
          type="text"
          readonly
          placeholder="Insert value"
        >
      </div>
    </div>  
  </div>
  <div class="modal-footer pt-5">
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Cancel</button>
    <button class="btn btn-default ml-3" [ngClass]="{'btn-disabled disabled': validation}" type='submit'>Save</button>
  </div>
</form>